<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      <h1 class="title">Dashboard</h1>
    </div>
    <p>Resumen general del sistema</p>
  </div>
  <div class="dashboard">
    <!-- METRICS -->
    <!-- <div class="metrics">
      <div class="card">
        <h3>Usuarios</h3>
        <p class="value">1,245</p>
        <span class="trend up">+12%</span>
      </div>

      <div class="card">
        <h3>Ventas</h3>
        <p class="value">$8,430</p>
        <span class="trend up">+8%</span>
      </div>

      <div class="card">
        <h3>Pedidos</h3>
        <p class="value">320</p>
        <span class="trend down">-3%</span>
      </div>

      <div class="card">
        <h3>Conversiones</h3>
        <p class="value">4.5%</p>
        <span class="trend up">+1.2%</span>
      </div>
    </div> -->

    <!-- KPIS COSTOS INTEGRALES -->
    <div class="kpi-grid">
      <div class="chart-card">
        <h3>Costos por {{ termkey.SectorSingular | term }} por año</h3>
        <div class="chart-wrapper">
          <canvas id="costsBySectorChart"></canvas>
        </div>
      </div>

      <div class="chart-card">
        <h3>Fuentes de financiación en el año</h3>
        <div class="chart-wrapper">
          <canvas id="fundingSourceChart"></canvas>
        </div>
      </div>

      <div class="chart-card">
        <h3>Costos por {{ termkey.AssistanceSingular | term }}</h3>
        <div class="chart-wrapper">
          <canvas id="costsByAssistanceChart"></canvas>
        </div>
      </div>

      <!-- KPI TABLE -->
      <div class="chart-card">
        <h3>Indicadores generales</h3>
        <table class="kpi-table">
          <thead>
            <tr>
              <th>Item</th>
              <th>Valor</th>
            </tr>
          </thead>
          <tbody>
            @for (kpi of kpiTable; track kpi.item) {
              <tr>
                <td>{{ kpi.item }}</td>
                <td>{{ kpi.valor }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
